import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert, Button, Paper } from '@mui/material';
import { setAdminSession } from '../../lib/adminAuth';

export default function AdminVerify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('No token provided');
      setLoading(false);
      return;
    }

    (async () => {
      try {
        const res = await fetch('/api/admin/verify-magic-link', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Verification failed');

        setAdminSession(data.token);
        navigate('/admin', { replace: true });
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    })();
  }, [searchParams, navigate]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fafafa' }}>
      <Paper elevation={0} sx={{ width: 400, p: 5, borderRadius: 3, border: '1px solid #eee', textAlign: 'center' }}>
        {loading && !error ? (
          <>
            <CircularProgress size={32} sx={{ color: '#1a1a2e', mb: 2 }} />
            <Typography sx={{ color: '#888' }}>Verifying your magic link...</Typography>
          </>
        ) : (
          <>
            <Alert severity="error" sx={{ mb: 3, borderRadius: 2, textAlign: 'left' }}>{error}</Alert>
            <Button component={Link} to="/admin/login" sx={{ textTransform: 'none', color: '#1a1a2e' }}>
              Back to Login
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
